import React, { useState,useEffect } from "react";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";

function OtherCompanyProducts() {
    const ID = Cookies.get("log_id");
    const [products,setProducts] = useState([]);
    function FetchOtherCompanyProducts() {
        axios.get(`${url.path}/fetch_other_company_products/${ID}/`)
        .then((res) =>{
            if(res.data.status){
                var prods = res.data.products;
                setProducts([])
                prods.map((e)=>{
                    setProducts((prevState)=>[
                        ...prevState, e
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        FetchOtherCompanyProducts();
    }, [])
     const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);

    const filteredData = products.filter((item) =>
      item.Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#productstable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
    return(
        <>
        <CompanyNavbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>Other Company Products</h3>
            </center>
            <div className="search-container">
                <input
                type="text"
                placeholder="Search..."
                onKeyUp={searchTable}
                className="search-input"
                id="search"
                />
            </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Description</th>
            <th>HSN/SAC</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {products.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Name}</td>
              <td>{i.Description}</td>
              {i.HSN ? (
                  <td>{i.HSN}</td>  
                ) : (
                    <td>{i.SAC}</td>
                )}
              <td>{i.Price}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default OtherCompanyProducts;